// 側邊欄 星塵數量
import React from 'react';

interface Props {
    stardust?: {
        balance?: number;
        expiringThisMonth?: number;
        usedThisMonth?: number;
    };
}

const AsideDustInfo = ({ stardust }: Props) => {
    const { balance = 0, expiringThisMonth = 0, usedThisMonth = 0 } = stardust || {};

    const dustItems = [
        { value: balance, label: '持有星塵', color: 'text-plum' },
        { value: expiringThisMonth, label: '即將過期', color: 'text-cobalt3' },
        { value: usedThisMonth, label: '本月消耗', color: 'text-purple7' },
    ];

    const formattedValues = dustItems.map((item) => item.value.toLocaleString());
    const totalLength = formattedValues.reduce((sum, v) => sum + v.length, 0);
    const fontSizeClass = totalLength > 11 ? 'text-h5' : totalLength > 9 ? 'text-h4' : 'text-h2';

    return (
        <div className="center-center pb-3 border-b gap-x-3 border-dashed border-black2 text-center select-none">
            {dustItems.map((item, index) => (
                <React.Fragment key={item.label}>
                    <div className="shrink-0">
                        {/* 星塵數量 */}
                        <p
                            className={`${fontSizeClass} ${item.color} tabular-nums whitespace-nowrap`}
                        >
                            {formattedValues[index]}
                        </p>
                        <p className="text-bd3n text-black4">{item.label}</p>
                    </div>
                    {index < dustItems.length - 1 && (
                        <span className="w-px h-2.75 border-l border-black2 opacity-30" />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default AsideDustInfo;
